module.exports = __webpack_public_path__ + "img/phone-dark.87b65f94.svg";